import {
  tabs,
  summary_cards,
  suppliers,
  documents_cards,
  documents_rows,
  renewals_rows,
  incidents_cards,
  incidents_rows,
  revalidation_empty,
  revalidation_flagged,
  drawer_catalog
} from './supplier_reigter_data.js';
import { revalidation_reason_options, supplier_category_options, supplier_status_options } from './supplier_register_helpers';
import { supplier_register_before_unmount, supplier_register_computed, supplier_register_created, supplier_register_methods, supplier_register_watch } from './supplier_register_ui';

export default {
  name: 'ComplyonSupplierRegister',
  data: () => ({
    tabs,
    summary_cards,
    suppliers: suppliers.map((row) => ({ ...row })),
    documents_cards,
    documents_rows,
    renewals_rows,
    incidents_cards,
    incidents_rows,
    revalidation_empty,
    revalidation_flagged,
    active_tab: 'register',
    drawer_catalog: { ...drawer_catalog },
    active_drawer_key: null,
    active_document_drawer_key: null,
    active_renewal_drawer_key: null,
    active_incident_drawer_key: null,
    active_flagged_drawer_key: null,
    document_drawer_catalog: {},
    renewal_drawer_catalog: {},
    incident_drawer_catalog: {},
    flagged_drawer_catalog: {},
    supplier_modal_open: false,
    revalidation_modal_open: false,
    revalidation_reason_options,
    active_revalidation_supplier: null,
    active_revalidation_reason: revalidation_reason_options[0],
    supplier_category_options,
    supplier_status_options,
    supplier_form: { name: '', category: 'Technology', status: 'Active', risk_score: '30', owner: '', annual_spend: '', supplier_since: '' }
  }),
  computed: supplier_register_computed,
  watch: supplier_register_watch,
  created: supplier_register_created,
  beforeUnmount: supplier_register_before_unmount,
  methods: supplier_register_methods
};
